import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useIsMobile from '../../hooks/useIsMobile'
import Item from './Item'
import { CloseButton, Container, Content, ContentMiddle, FooterContent } from './styles'
import Button from '../Button'

import Avatar from '../Avatar'
import { useConfigStore } from '../../store/config'
import { ContentCenter } from '../commons'
import { handleLogout } from '../../utils/utils'
import { useUserStore } from '../../store/user'
import { useTheme } from 'styled-components'
import { FaChartArea, FaFile, FaFilePen, FaHouse, FaUser, FaUsers, FaXmark, FaChartPie, FaCode, FaCheckDouble } from 'react-icons/fa6'
import { useDirectory } from '../../store/directory'

export interface DrawerProps {
  title?: string
}

export interface DrawerHandle {
  handleModal: () => void
}

export interface RoutesProps {
  label: string
  to: string
  Icon: any
  admin: boolean
  disabled?: boolean
}

const routes: RoutesProps[] = [
  {
    label: 'Início',
    to: '/',
    Icon: FaHouse,
    admin: true,
  },
  {
    label: 'Gerenciador de Documentos',
    to: '/documents',
    Icon: FaFile,
    admin: false,
  },
  {
    label: 'Conferência (SIM)',
    to: '/conferencia',
    Icon: FaCheckDouble,
    admin: false,
  },
  {
    label: 'Tipos de Documentos',
    to: '/documentTypes',
    Icon: FaFilePen,
    admin: true,
  },
  {
    label: 'Integração com API',
    to: '/api-integration',
    Icon: FaCode,
    admin: true,
  },
  {
    label: 'Relatórios e Estatísticas',
    to: '/reports',
    Icon: FaChartPie,
    admin: true,
  },
  {
    label: 'Gerenciador de usuarios',
    to: '/users',
    Icon: FaUser,
    admin: true,
  },
  {
    label: 'Gerenciador de grupos',
    to: '/groups',
    Icon: FaUsers,
    admin: true,
  },
  {
    label: 'Logs',
    to: '/logs',
    Icon: FaChartArea,
    admin: true,
  },
]

const Drawer: React.ForwardRefRenderFunction<DrawerHandle, DrawerProps> = ({ title }, ref) => {
  const isMobile: boolean = useIsMobile()
  const [open, setOpen] = React.useState(false)
  const { pathname } = useLocation()

  const theme: any = useTheme()

  const config = useConfigStore((state) => state).config
  const user = useUserStore((state) => state).user

  const navigate = useNavigate()

  React.useImperativeHandle(ref, () => ({
    handleModal() {
      setOpen((old) => !old)
    },
  }))

  const changePage = (to: string) => {
    if (pathname === '/' && to === '/') return true

    if (to === '/') return false

    return pathname.startsWith(to)
  }

  const onChangePage = (to: string) => {
    // Se navegando para documentos, resetar para pasta raiz
    if (to === '/documents') {
      useDirectory.getState().setDirectory([
        {
          name: 'Início',
          url: '/',
        },
      ])
    }
    
    navigate(to)
    setOpen(false)
  }

  return (
    <Container open={open} isMobile={isMobile}>
      <Content open={open} isMobile={isMobile}>
        <CloseButton onClick={() => setOpen(false)}>
          <FaXmark size={35} />
        </CloseButton>
        <ContentCenter style={{ marginBottom: 15 }}>
          <Avatar borderRadius={15} width={150} height={150} source={config?.logo} />
        </ContentCenter>

        <ContentMiddle>
          {routes.map((item) => {
            if ((user?.role !== 'admin' && !item.admin) || user?.role === 'admin')
              return (
                <Item
                  Icon={item.Icon}
                  key={item.to}
                  navigatePage={() => onChangePage(item.to)}
                  active={changePage(item.to)}
                  disabled={!!item.disabled}
                  to={item.to}
                  label={item.label}
                />
              )
          })}
        </ContentMiddle>

        <FooterContent>
          <Button
            onClick={() => handleLogout()}
            variantType='label'
            color='primary'
            label='Logout'
          />
        </FooterContent>
      </Content>
    </Container>
  )
}

export default React.forwardRef(Drawer)
